import React from 'react';

interface WritsExtendedProps {}

export function WritsExtended(props: Readonly<WritsExtendedProps>) {
	return (
		<svg width={138} height={60} viewBox="0 0 138 60" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<g clipPath="url(#clip0_2182_17116)">
				<path
					fill="#999"
					d="M50.523 37.393c1.119 1.76 1.43 3.432 1.219 5.514-.21 2.083-.978 4.39-2.343 5.592-.945.831-2.736 1.805-4.311 2.376-3.522 1.276-9.464 1.185-11.77.874C5.848 48.043 7.87 47.64-1.672 46.1c-15.904-2.568-33.93-6.078-36.176-7.07-2.246-.99-5.914-3.65-7.1-5.01-1.187-1.36-4.092-5.105-4.016-8.271.075-3.166.998-5.596 2.673-8.275 1.675-2.68 4.315-3.966 6.284-4.42 2.362-.546 6.209-.153 9.11.31 9.192 1.598 18.08 4.3 27.075 7.693 7.13 2.783 10.028 5.082 17.255 7.828a81.522 81.522 0 0025.144 4.696c2.016-.054 4.795.343 6.15.558 1.354.216 4.735 1.587 5.796 3.255z"
				/>
				<path d="M115.02 56.862V44.46h3.1v12.4h-3.1z" stroke="#71828F" strokeWidth={2} strokeLinecap="round" />
				<path d="M-30.688 58.64h182.914" stroke="#BEC4CB" strokeWidth={2} strokeLinecap="round" />
				<path
					stroke="#71828F"
					strokeWidth={2}
					strokeLinecap="round"
					d="M95.309 41.04l-5.442 1.312M83.02 43.902l-5.443 1.313M70.754 46.898l-5.442 1.313M119.859 35.184l-5.442 1.312M107.598 38.176l-5.442 1.313"
				/>
				<path
					fill="#445662"
					d="M52.161 54.294c-.523-2.935 2.22-3.543 2.22-3.543l73.383-17.517c3.195-.569 6.208 1.31 6.723 4.203.514 2.89-1.664 5.693-4.86 6.262L56.145 56.786s-3.461.444-3.984-2.492z"
				/>
				<path
					fill="#999"
					d="M75.132 29.205c.489.196 9.99 3.583 10.886 6.188.023 3.109-2.72 4.037-3.417 4.461-2.099 1.275-9.986-1.495-13.364-.18 0 0-2.05.869-4.58 1.854-2.529.985-4.813 1.767-4.813 1.767-3.345 1.736-10.533 6.374-10.533 6.374-2.387 1.492-3.26 1.845-4.434 2.128-2.958.713-7.292.544-7.936.363 0 0-1.621-.314-2.982-1.6 0 0-1.596-2.18-2.194-3.915-.597-1.736.4-4.356.4-4.356.504-1.017 3.43-5.114 4.661-6.607 1.231-1.492 4.895-4.01 5.12-4.055 0 0 2.129-1.463 5.435-3.336 2.02-.83 4.169-3.374 4.169-3.374 1.264-1.412 2.49-1.797 2.49-1.797 2.179-.88 3.756-.484 5.662.686 1.872 1.006 6.023 1.164 8.02 2.05 1.995.888 6.92 3.153 7.41 3.35z"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2182_17116">
					<path fill="#fff" d="M0 0H138V60H0z" />
				</clipPath>
			</defs>
		</svg>
	);
}
